export default "__VITE_ASSET__BPTjpCGv__"